import type { ProductModelV2 } from '@develop/ia-api-library'
import { checkReorderAvailability, getUserOrders, searchProductsV2 } from '@develop/ia-api-library'
import type { ProductWithRemainingAllowedQuantity } from '../models/my-account-models'

export const useReorderData = () => {
  const authStore = useAuthStore()
  const { pharmacy } = useCurrentPharmacyStore()
  const productList = ref<ProductModelV2[]>([])

  // This could be fetched server-side with useAsyncData
  const loadReorderData = (orderId: number, pzn?: string | string[]) => {
    return useAsyncState(async () => {
      const { data: userOrders } = await getUserOrders({
        token: authStore?.token ?? '',
        refreshToken: authStore?.refreshToken ?? '',
      })

      const orderData = userOrders?.data.find(item => item.id === orderId)

      const pznArr = pzn ? ensureArray(pzn) : undefined
      const orderPznList = pznArr || (orderData?.products.map(item => item.pzn!) ?? [])

      const { data: productAvailability } = await checkReorderAvailability({
        PZNs: orderPznList,
        pharmacyId: pharmacy!.id,
        orderNumber: orderId,
      })

      const { data: productData } = await searchProductsV2(
        1, // PAGE
        {
          pharmacyId: pharmacy!.id,
          resultsPerPage: orderPznList.length,
          activeSubstances: [],
          categories: [],
          dosages: [],
          producers: [],
          products: orderPznList,
          type: 'pharmacy',
          volumes: [],
          searchTerm: 'match_all',
          sorting: 'name-asc',
        },
      )

      productList.value = productData?.results.filter(item => !productAvailability?.unavailable.includes(item.pzn)) ?? []

      return {
        orderData,
        productAvailability,
        productDetails: productData?.results as ProductWithRemainingAllowedQuantity[],
      }
    }, null)
  }

  return {
    loadReorderData,
    productList,
  }
}
